import AmexShopSmallBuyoutNotifyButton from './AmexShopSmallBuyoutNotifyButton';

export default AmexShopSmallBuyoutNotifyButton;
